// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Summary_wrapper__1E9Wa","title":"Summary_title__27dYq","text":"Summary_text__15PHx","actionButtons":"Summary_actionButtons__13Tuc"};